import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/carApplications/detail',
    method: 'get',
    params: data,
  })
}
export async function searchData(data) {
  return request({
    url: '/carApplications/get',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: '/v6/carApplications/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/v6/carApplications/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/carApplications/delete',
    method: 'post',
    data,
  })
}
export async function push(data) {
  return request({
    url: '/carApplications/pushV2',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/carApplications/revoke',
    method: 'post',
    data,
  })
}
export async function approvalProcess(data) {
  return request({
    url: '/v2/carApplications/check/process/info',
    method: 'post',
    data,
  })
}
export async function delay(data, url) {
  return request({
    url: '/' + url + '/delay',
    method: 'post',
    data,
  })
}
